import React, { Component } from "react"
import { Row, Col } from "reactstrap"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}>{new Date().getFullYear()} ©. Mobihunter CRM</Col>
              <Col sm={6}>
                <div className="text-sm-end d-none d-sm-block">
                 Develop by <a href="https://www.linkedin.com/company/ytc-db/about" rel='noreferrer' target="_blank">YTC</a>
              </div>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

export default Footer;
